// permissions/routesMap.ts
// 管理员的路由权限 - 拥有所有权限
const adminRoutes = ['/'];

// 用户层级的路由权限 - 按模块划分
const userRoutes = {
  // 基础模块
  // 在 userRoutes.basic 数组中添加
  basic: [
    '/overview',
    // '/dataAnalysis',
    // '/dataAnalysis/dataOverview',
    // '/dataAnalysis/dailyDataAnalysis',
    '/customerManagement',
    '/customerManagement/clientList',
    // '/customerManagement/clientGrouping',
    '/invitationPromotion',
    '/invitationPromotion/invitationLink',
    // '/invitationPromotion/customRegistrationPage',
    '/customerManagement/operationRecord',
    '/financialDetails',
    '/financialDetails/commission',
    '/financialDetails/transaction',
    '/financialDetails/dailySummary'
  ],
  
  // 数据图表模块
  overview: [
    '/overview',
  ],

  // 数据分析模块
  dataAnalysis: [
    '/dataAnalysis',
    '/dataAnalysis/dataOverview',
    '/dataAnalysis/dailyDataAnalysis'
  ],

  customerManagement: [
    '/customerManagement',
    '/customerManagement/clientList',
    '/customerManagement/clientGrouping',
    '/customerManagement/operationRecord'
  ],

  superAgentSystem: [
    // '/customerManagement/superAgentSystem'
  ],

  invitationPromotion: [
    '/invitationPromotion',
    '/invitationPromotion/invitationLink',
    '/invitationPromotion/customRegistrationPage',
    // '/invitationPromotion/invitationReviewRecord'
  ],

  financialDetails: [
    '/financialDetails',
    '/financialDetails/commission',
    '/financialDetails/transaction',
    '/financialDetails/dailySummary'
  ],

  supportCenter: [
    '/supportCenter',
    '/supportCenter/materialLibrary',
    '/supportCenter/helpCenter'
  ],

  activityCenter: [
    '/activityCenter'
  ],
};

// 不同角色的默认路由组合
export const roleRoutesMap = {
  admin: [           // 经理级别 - 拥有系统管理和基础功能
    ...userRoutes.basic,
    ...userRoutes.superAgentSystem,
  ],

  agent: [
    ...userRoutes.basic,
    ...userRoutes.superAgentSystem
  ],
  
  user: [              // 普通用户 - 只有基础功能
    ...userRoutes.basic
  ],
  
  guest: [             // 访客 - 最小权限
    '/overview'
  ]
};
